/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanySearchFilterSortSpec = 'ByNumberASC' | 'ByNameASC' | 'BySegaActiveASC' | 'ByTopCompanyASC' | 'ByCompanyProfileV3ActiveASC' | 'ByCompanyProfileV2ActiveASC' | 'ByCompanyProfileV2ActiveDESC' | 'ByCompanyProfileV3ActiveDESC' | 'ByTopCompanyDESC' | 'BySegaActiveDESC' | 'ByNameDESC' | 'ByNumberDESC';

export const CompanySearchFilterSortSpec = {
    ByNumberASC: 'ByNumberASC' as CompanySearchFilterSortSpec,
    ByNameASC: 'ByNameASC' as CompanySearchFilterSortSpec,
    BySegaActiveASC: 'BySegaActiveASC' as CompanySearchFilterSortSpec,
    ByTopCompanyASC: 'ByTopCompanyASC' as CompanySearchFilterSortSpec,
    ByCompanyProfileV3ActiveASC: 'ByCompanyProfileV3ActiveASC' as CompanySearchFilterSortSpec,
    ByCompanyProfileV2ActiveASC: 'ByCompanyProfileV2ActiveASC' as CompanySearchFilterSortSpec,
    ByCompanyProfileV2ActiveDESC: 'ByCompanyProfileV2ActiveDESC' as CompanySearchFilterSortSpec,
    ByCompanyProfileV3ActiveDESC: 'ByCompanyProfileV3ActiveDESC' as CompanySearchFilterSortSpec,
    ByTopCompanyDESC: 'ByTopCompanyDESC' as CompanySearchFilterSortSpec,
    BySegaActiveDESC: 'BySegaActiveDESC' as CompanySearchFilterSortSpec,
    ByNameDESC: 'ByNameDESC' as CompanySearchFilterSortSpec,
    ByNumberDESC: 'ByNumberDESC' as CompanySearchFilterSortSpec
};

